/**
 * Airline alliances — shared constants used by:
 *   - the Vendors page Add/Edit Vendor dialog (conditional Select)
 *   - the inline AddVendorDialog (conditional Select)
 *   - the Vendors page alliance filter dropdown
 *   - the alliance chip on each airline vendor card
 *
 * The auto-seed script (`/app/backend/scripts/seed_airline_alliances.py`)
 * uses a parallel mapping in Python; keep that file in sync if airlines
 * change alliance affiliation. Membership data per the official alliance
 * member rosters at the time of writing (Feb 2026).
 */

export const ALLIANCES = [
  "Star Alliance",
  "SkyTeam",
  "Oneworld",
  "Independent",
];

// Brand color per alliance — used for the chip background. Picked to be
// recognizable without exactly mimicking the alliance trademarks.
export const ALLIANCE_COLORS = {
  "Star Alliance": "bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  "SkyTeam":       "bg-sky-100 text-sky-800 border-sky-300 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800",
  "Oneworld":      "bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800",
  "Independent":   "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
};

// Tiny inline glyph per alliance — keeps the chip visually distinct
// without pulling in icon assets.
export const ALLIANCE_GLYPHS = {
  "Star Alliance": "★",
  "SkyTeam":       "✈",
  "Oneworld":      "◯",
  "Independent":   "·",
};
